import { graphql } from '@/generated/gql';

export const SOURCING_CASE_DETAIL_QUERY = graphql(/* GraphQL */ `
  query TsrctSourcingCaseDetail($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        id
        status
        sequenceNumber
        createdAt
        updatedAt
        isNegotiationEnabled
        isSupplierUploadAllowed
        issues {
          id
          status
          variant
        }
        demand {
          id
          sequenceNumber
        }
        supplier {
          id
          name
          supplierId
          contact {
            id
            firstName
            lastName
            email
            internalId
          }
        }
        quote {
          id
          status
          createdAt
          currency
          supplierReference
          validFrom
          validTo
          paymentTermsId
          incoTermsId
          lineItems {
            id
            sequence
            createdAt
            title
            description
            unitId
            commodityId
            deliveryLocationId
            status
            organizationId
            priceUnit
            pricePerPriceUnit
            pricePerUnit
            minimumOrderQuantity
            quantity
            discountedPricePerUnit
            totalDiscountedValue
            totalValue
            demandRequestItemId
            bidDeclinedReason
            bidDeclinedReasonText
          }
        }
      }
    }
  }
`);

export const RELEASE_SOURCING_CASE_MUTATION = graphql(/* GraphQL */ `
  mutation TsrctReleaseSourcingCase($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        release
      }
    }
  }
`);

export const DELETE_SOURCING_CASE_MUTATION = graphql(/* GraphQL */ `
  mutation TsrctDeleteSourcingCase($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        delete
      }
    }
  }
`);

export const CANCEL_SOURCING_CASE_MUTATION = graphql(/* GraphQL */ `
  mutation TsrctCancelSourcingCase($id: UUID!, $data: TsrctSourcingCaseCancelInput) {
    tesseract {
      sourcingCase(id: $id) {
        cancel(data: $data) {
          id
          status
          cancellationReason
          cancellationReasonText
          updatedAt
          demand {
            id
          }
        }
      }
    }
  }
`);

export const REMIND_SOURCING_CASE_MUTATION = graphql(/* GraphQL */ `
  mutation TsrctRemindSourcingCase($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        sendReminder {
          id
        }
      }
    }
  }
`);

export const RESET_SOURCING_CASE_MUTATION = graphql(/* GraphQL */ `
  mutation TsrctResetSourcingCase($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        reset {
          id
          status
          sequenceNumber
          createdAt
          updatedAt
          isNegotiationEnabled
          issues {
            id
            status
            variant
          }
          demand {
            id
            sequenceNumber
          }
          supplier {
            id
            name
            supplierId
            contact {
              id
              firstName
              lastName
              email
              internalId
            }
          }
          quote {
            id
            status
            createdAt
            currency
            supplierReference
            validFrom
            validTo
            paymentTermsId
            incoTermsId
            lineItems {
              id
              sequence
              createdAt
              title
              description
              unitId
              commodityId
              deliveryLocationId
              status
              organizationId
              priceUnit
              pricePerPriceUnit
              pricePerUnit
              minimumOrderQuantity
              quantity
              discountedPricePerUnit
              totalDiscountedValue
              totalValue
              demandRequestItemId
              bidDeclinedReason
              bidDeclinedReasonText
            }
          }
        }
      }
    }
  }
`);
